import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesHistoryVisitList {
    constructor(
    ) { }

    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {

        const RiQi = localStorage.getItem('historyVisitDate');
        let requestBody = JSON.parse(webcontext.RequestBody);
        requestBody['a_VisitDate']['BeforeValue'] = RiQi + ' 00:00:00';
        requestBody['a_VisitDate']['EndValue'] = RiQi + ' 23:59:59';

        webcontext.RequestBody = JSON.stringify(requestBody);
        webcontext.ResponseMessage.Success = true;
        webcontext.ResponseMessage.ErrorMessage = "";
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        // webContext.url = '/tabs/contact/Calendar';
        return webContext;
    }

}